import { PeriscopeApexClass } from '../apex-classes';

export const PeriscopeApexTrigger = PeriscopeApexClass;
